import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { YesNoModal } from '../../modals/yes-no-modal/yes-no-modal.component';
import { MessageModal } from '../../modals/message-modal/message-modal.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

@Injectable()
export class DialogService {
    private dialog = inject(MatDialog);

    confirmUnsavedChanges(setNoButtonAsDefault?: boolean): Observable<boolean> {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = {
            headerTitle: "Unsaved Changes!",
            message: "Are you sure you want to leave this page?",
            yesText: "Yes, Discard and Leave this Page",
            noText: "Stay on this Page",
            setNoButtonAsDefault: setNoButtonAsDefault
        };
        return this.dialog.open(YesNoModal, dialogConfig).afterClosed();
    };

    showMessage(title: string, message: string, buttonText?: string): Observable<void> {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = {
            headerTitle: title,
            message: message,
            okText: buttonText
        };
        return this.dialog.open(MessageModal, dialogConfig).afterClosed();
    }
}
